export const PAGE_KEYS = {
  HOME: "home",

  // RACK_PRICING
  VERIFY: "verify",
  RACK_CONFIRMATION: "rack-confirmation",
  RACK_CONFIRMATION_WEEKEND_HOLIDAY: "rack-confirmation-weekend-holiday",
  RACK_PRICING: "rack-pricing",
  BENCHMARK_ENTRY_PLATTS: "benchmark-entry__platts",
  BENCHMARK_ENTRY_ARGUS: "benchmark-entry__argus",
  WET_MOVE_GAS: "wet-move__gas",
  WET_MOVE_DIESEL: "wet-move__diesel",
  WET_MOVE_CONFIGURATION: "wet-move__configuration",
  DTN_UPLOAD: "dtn-upload",

  // RACK_FEATURES
  OUTAGE: "outage",
  RACK_DEFINITION: "rack-definition",
  RACK_CONTRACT_FORMULA: "rack-contract__formula",
  RACK_CONTRACT_FORMULA_LOW_MAP: "rack-contract__formula-low-map",
  RACK_CONTRACT_VARIABLES: "rack-contract__variables",
  TERMINAL_GROUP: "terminal-group",
  TERMINAL_GROUP_MAP: "terminal-group__group-terminal-map",
  RACK_NOTE: "rack-note",
  RACK_PRICING_GROUP: "rack-pricing-group",
  SALES_REP: "sales-rep",
  CUSTOMER_RACK_EMAIL: "customer-rack-email",
  DAILY_ALLOCATION: "allocation__daily-allocation",
  ALLOCATION_SETUP: "allocation__allocation-setup",
  CUSTOMER_RACK_SELECTION: "customer-rack-selection",
  FORMULA_OPIS: "formula-opis",
  FORMULA_OPIS_CITY_CONTRACT_GROUP: "formula-opis__city-contract-group",
  FORMULA_OPIS_CITY_CONTRACT_GROUP_MAP: "formula-opis__city-contract-group-map",
  RACK_MESSAGING: "rack-messaging",

  // BID_PRICING
  BID_PRICING: "bid-pricing",
  BID_CONFIRMATION: "bid-confirmation",

  // BID_FEATURES
  BID_DEFINITION: "bid-definition",
  BID_FREIGHT: "bid-freight",
  CUSTOMER_PRICING_SETUP: "customer-pricing-setup",
  BID_TERMINAL_GROUP: "bid-terminal-group__group",
  BID_TERMINAL_GROUP_CONTRACTS: "bid-terminal-group__contracts",
  CUSTOMER_BID_EMAIL: "customer-bid-email",

  // REPORTS
  BID_PRICE_FLOOR: "bid-price-floor",
  CUSTOMER_BID_PRICING: "customer-bid-pricing",
  OPIS_LOW_REPORT: "opis-low-report",
  CUSTOMER_CONTRACT_REPORT: "customer-contract-report",
  RACK_PRICING_REPORT: "rack-pricing-report",
  BID_PRICING_REPORT: "bid-pricing-report",
  RACK_CONTRACT_REPORT: "rack-contract-report",
  CUSTOMER_TERMINAL_REPORT: "customer-terminal-report",
  SUMNER_COUNTY_REPORT: "sumner-county-report",
  TRANSPORT_PICK_LIST_REPORT: "transport-pick-list-report",
  PRODUCT_SUPPLY_REPORT: "product-supply-report",
  BID_MARGIN_REPORT: "bid-margin-report",
  PDI_COST_MARGIN_REPORT: "pdi-cost-margin-report",

  // SETUP
  CALENDAR_SCHEDULE: "calendar-schedule",
  CUSTOMER: "customer",
  CUSTOMER_BID_SELECTION: "customer__bid-selection",
  CUSTOMER_DTN_TERMINALS: "customer__dtn-terminals",
  CUSTOMER_RELATIONSHIPS: "customer__relationships",
  DTN_CITY: "dtn-city",
  DTN_CITY_TERMINAL: "dtn-city__terminal",
  FAST_RACKS_SETUP: "fast-racks-setup",
  FAST_RACKS_FREIGHT: "fast-racks-freight",
  FAST_RACKS_TAX: "fast-racks-tax",
  FUEL_SUPPLIER: "fuel-supplier",
  FUEL_SUPPLIER_EXCLUSIONS: "fuel-supplier__exclusions",
  FUEL_SUPPLIER_COST_MAP: "fuel-supplier-cost-map",
  OPIS_CITY: "opis-city",
  PDI_PRICING_SETUP: "pdi-pricing-setup",
  PDI_SYNC: "pdi-sync",
  FUEL_PRODUCT: "fuel-product",
  SETTINGS: "settings",
  SETTINGS_ALLOWED: "settings__settings-allowed",
  STATES: "states",
  TAX: "tax",
  TERMINAL: "terminal",
  TIME_SETUP_FRAME: "time-setup__frame",
  TIME_SETUP_ZONE: "time-setup__zone",
  VERIFY_BENCHMARK_ARGUS: "verify-benchmark__argus",
  VERIFY_BENCHMARK_DTN: "verify-benchmark__dtn",
  VERIFY_BENCHMARK_PLATTS: "verify-benchmark__platts",
  VERIFY_BENCHMARK_OPIS: "verify-benchmark__opis",
  VERIFY_BENCHMARK_RACK_VERIFY: "verify-benchmark__rack-verify",
  STORED_PROCS: "stored-procs",

  //QUARTZ
  QUARTZ: "quartz",
};
